export enum serverResponseErrors {
  serverError = 'SERVER_ERROR',
  server503 = '503',
}
export enum registerResponseErrors {
  tooManyRequests = 'IDAERR0042',
  alreadyExists = 'IDAERR0043',
  wrongCredentials = 'IDAERR0044',
}